import request from "@/utils/request";

// 列表(主数据列表)
export function loadDepotListDataApi(data) {
  return request({
    url: "web/depot/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadDepotExportDataApi(data) {
  return request({
    url: "web/depot/exportData",
    method: "post",
    data
  });
}

// 初始化
export function initDepotApi(data) {
  return request({
    url: "web/depot/initDepot",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateDepotApi(data) {
  return request({
    url: "web/depot/saveOrUpdate",
    method: "post",
    data
  });
}

// 下拉
export function depotListSelectDataApi(data) {
  return request({
    url: "web/depot/listSelectData",
    method: "post",
    data
  });
}
